export const ROUTES = {
  home: '/',
  videoWaitingRoom: (appointmentId: string) => `/video/${appointmentId}`,
  phoneWaitingRoom: (appointmentId: string) => `/phone/${appointmentId}`,
  videoMeeting: (appointmentId: string, meetingId: string) => `/video/${appointmentId}/meeting/${meetingId}`,
  joinPhoneMeeting: (appointmentId: string) => `/phone/${appointmentId}/join`,
  phoneMeeting: (appointmentId: string, meetingId: string) => `/phone/${appointmentId}/meeting/${meetingId}`,
  videoMeetingLeft: '/video/meeting-left',
  phoneMeetingLeft: '/phone/meeting-left'
} as const

const MARKETPLACE_URL = import.meta.env.VITE_MARKETPLACE_FRONTEND_URL ?? 'http://localhost:4001'

export const APP_FRONTEND_ROUTES = {
  review: (appointmentId: string) => buildMarketplaceUrl(`/review/${appointmentId}`)
}

const buildMarketplaceUrl = (path: string) => {
  return `${MARKETPLACE_URL}${path}`
}
